module.exports = __webpack_public_path__ + "static/media/booth-curtain.28fcce44.svg";